import { useStoreState, useStoreActions } from 'easy-peasy';
import { PropTypes } from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { StyledFilter } from '@ge/components/assets-filter';
import { Select } from '@ge/components/select';
import { TabFlowModelVariables } from '@ge/models/constants';

const AllUserRolesComponent = ({ dropdownItems }) => {
  const { t } = useTranslation(['admin.people'], { useSuspense: false });

  const { viewByServiceGroupsOrSites, disabledTab } = useStoreState(
    (state) => state.tabflow.personAssets,
  );
  const { changeState } = useStoreActions((actions) => actions.tabflow);

  return (
    <div>
      <div className="all-user-roles-grid"></div>
      <div>
        <div className="person-assets-sites-filter-content">
          <div className="person-assets-align-self">
            <Select
              disabled={disabledTab}
              label={t('assets.view_by', 'View by')}
              maxWidth={175}
              minWidth={175}
              onChange={(option) =>
                changeState({
                  name: TabFlowModelVariables.VIEWBYSERVICEGROUPORSITES,
                  value: option.value,
                })
              }
              options={dropdownItems}
              value={dropdownItems.filter((option) => option.value === viewByServiceGroupsOrSites)}
            />
          </div>

          <div className="person-assets-sites-filter-right-item-second">
            <StyledFilter searchByName={viewByServiceGroupsOrSites} />
          </div>
        </div>
      </div>
    </div>
  );
};
AllUserRolesComponent.propTypes = {
  dropdownItems: PropTypes.array,
};

export default AllUserRolesComponent;
